<script setup lang="ts">
import TableEmptyText from '@/components/texts/TableEmptyText.vue';

export interface DataItem {
  _id: string;
  num: number;
  type: string;
  volume: string;
  weight: string;
}

export interface Props {
  data?: DataItem[];
}
const props = withDefaults(defineProps<Props>(), {
  data: () => [],
});

const titleData = {
  num: 'Item #',
  type: 'Type',
  volume: 'Volume',
  weight: 'Weight',
};

const foldColspan = Object.keys(titleData).length;
</script>

<template>
  <table
    data-testid="productsConfirmStepNewAirRoadCustomTable"
    :class="$style.productsConfirmStepNewAirRoadCustomTable"
  >
    <thead>
      <tr>
        <template
          v-for="(titleValue, titleKey, titleIndex) in titleData"
          :key="titleKey"
        >
          <th :class="$style[titleKey + 'Th']">
            {{ titleValue }}
          </th>
        </template>
      </tr>
    </thead>
    <tr v-if="!props.data?.length">
      <td :colspan="foldColspan" class="border-b-0 p-0">
        <TableEmptyText>No AirRoad products</TableEmptyText>
      </td>
    </tr>
    <tbody v-else>
      <template v-for="(dataItem, dataIndex) in props.data" :key="dataItem._id">
        <tr>
          <template
            v-for="(titleValue, titleKey, titleIndex) in titleData"
            :key="titleKey"
          >
            <td :class="$style[titleKey + 'Td']">
              {{ dataItem[titleKey] }}
            </td>
          </template>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.productsConfirmStepNewAirRoadCustomTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  text-align: left;

  & > thead > tr,
  & > tbody > tr,
  & > tr { 
    & > th {
      font-weight: 500;
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > td {
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > th:first-child,
    & > td:first-child {
      padding-left: 0;
    }
    & > th:last-child,
    & > td:last-child {
      padding-right: 0;
    }
  }
}
  .numTh {
  }
  .typeTh {
  }
  .volumeTh {
  }
  .weightTh {
  }
  .numTd {
  }
  .typeTd {
  }
  .volumeTd {
  }
  .weightTd {
  }
</style>
